import { useState, useEffect } from 'react';
import useStorePage from '../store/usePage';
import Paywall from '../Paywall';
import { PageAnalytics } from '../analytics';

import { PaywallPageWrapper as PageWrapper } from '../styled';

interface PaywallProps {
  children: React.ReactNode;
  feature: string;
  isFlexible?: boolean;
  isWidget?: boolean;
}

function PaywallWrapper({
  children,
  feature,
  isFlexible,
  isWidget,
}: PaywallProps) {
  const [isReady, setReady] = useState<boolean>(false);
  const { isPro, isLoading, isRenewal } = useStorePage({ featureKey: feature });

  useEffect(() => {
    setReady(true);
  }, []);

  if (isLoading || !isReady) {
    return null;
  }

  if (isPro) {
    return <>{children}</>;
  }

  return (
    <PageWrapper isFlexible={isFlexible}>
      <Paywall
        source={PageAnalytics[feature]}
        isRenewal={isRenewal}
        isWidget={isWidget}
        height="272px"
      />
    </PageWrapper>
  );
}

export default PaywallWrapper;
